<template>
    <div class="main-container">
        <div class="d-flex">
            <div class="col-md-12">
                <b-tabs v-model="tabIndexCall">
                    <b-tab :title="'TabelaChamado'">
                        <template slot="title">
                            <div class="d-md-down none pl-1 text-third text-tabs"> Triagem </div>
                        </template>
                        <div class="painel-detalhes-main">
                            <infoSorting @openpdf="getInfoPdf" @goTovisitTechnical='changesTabs'  :statusOcorencia="statusOcorencia"  @nextstatus="NextStatus" :dataDetails="dataDetails" ></infoSorting>
                        </div>
                    </b-tab>

                    <b-tab :title="'TabelaChamado'">
                        <template slot="title">
                            <div class="d-md-down none pl-1 text-third text-tabs"> Vistoria Técnica </div>
                        </template>
                        <div class="painel-detalhes-main">
                            <technicalVisit :statusOcorencia="statusOcorencia" @resumo="resumo" @goToInputCost='changesTabs'  @nextstatus="NextStatus"  :dataDetails="dataDetails" ></technicalVisit>
                        </div>
                    </b-tab>

                    <b-tab :title="'TabelaChamado'" v-if="!hasRole(roles.RW_REAL_ESTA_USER_OBRA)">
                        <template slot="title">
                            <div class="d-md-down none pl-1 text-third text-tabs"> Insumos e Custos </div>
                        </template>
                        <div class="painel-detalhes-main">
                            <inputCosts :statusOcorencia="statusOcorencia" @goToDocumentOcurrence='changesTabs'  @nextstatus="NextStatus"  :dataDetails="dataDetails" style="overflow-x: hidden !important;"></inputCosts>
                        </div>
                </b-tab>

                    <b-tab :title="'TabelaChamado'" v-if="!hasRole(roles.RW_REAL_ESTA_USER_OBRA)">
                        <template slot="title">
                            <div class="d-md-down none pl-1 text-third text-tabs"> Documentos </div>
                        </template>
                        <div class="painel-detalhes-main">
                            <documentoccourences :statusOcorencia="statusOcorencia"  @nextstatus="NextStatus"  :detailsoccourence="dataDetails"></documentoccourences>
                        </div>
                    </b-tab>
                    <b-tab :title="'TabelaChamado'" v-if="!hasRole(roles.RW_REAL_ESTA_USER_OBRA)">
                        <template slot="title">
                            <div class="d-md-down none pl-1 text-third text-tabs"> Log </div>
                        </template>
                        <div class="painel-detalhes-main">
                            <logOcurrence ref="logOcurrence" :logtab="logtab" @nextstatus="NextStatus"  :dataDetails="dataDetails"></logOcurrence>
                        </div>
                    </b-tab>
                    <b-tab :title="'TabelaChamado'" v-if="dataDetails.statusOcorencia == 3 && !hasRole(roles.RW_REAL_ESTA_USER_OBRA)">
                        <template slot="title">
                            <div class="d-md-down none pl-1 text-third text-tabs"> Avaliação do Cliente </div>
                        </template>
                        <div class="painel-detalhes-main">
                            <ratingCustomer ref="ratingCustomer"  @nextstatus="NextStatus"  :dataDetails="dataDetails"></ratingCustomer>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
    <vue-html2pdf
      :show-layout="false"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1200"
      filename= "Vistoria Técnica"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      :pdf-margin="10"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @beforeDownload="abrirNovaGuia"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="pdf-header">
              <img src="/static/img/logotipo/menu/logo_zopone.png" class="size-logo-inco-pdf"/>
        </div>
        <div>
            <tr>
             <td class="codigoposition">Chamado N° <b>
                 {{dataDetailsPdf.codigo}}
            </b></td>
            </tr>
        </div>
       <div class="container-pdf">
            <div class="sub-title">1 - SOLICITANTE</div>
            <table class="table-pdf">
                <thead></thead>
                <tbody>
                    <tr>
                        <td v-if="dataDetailsPdf.empreendimentoNovaUnidade"  class="table-pdf-td">EMPREENDIMENTO:
                            <b>{{dataDetailsPdf.empreendimentoNovaUnidade.nomeEmpreendimento}}</b>
                        </td>
                        <td class="table-pdf-td">
                             UNIDADE:
                            <b>
                                {{dataDetailsPdf.nomeUnidade}}
                            </b></td>
                    </tr>
                    <tr>
                        <td class="table-pdf-td">ENDERECO: <b>
                            <!-- {{dataDetailsPdf.empreendimento.endereco}} -->
                        </b></td>
                        <td class="table-pdf-td">CIDADE: <b>
                            <!-- {{dataDetailsPdf.cidade.nome}} -->
                        </b></td>
                    </tr>
                    <tr>
                        <td class="table-pdf-td">NOME DO SOLICITANTE: <b>
                            {{dataDetailsPdf.nomeCliente}}
                        </b></td>
                        <td class="table-pdf-td">FONE: <b>
                            {{dataDetailsPdf.telefone}}
                        </b></td>
                    </tr>
                    <tr>
                        <td class="table-pdf-td" v-if="dataDetailsPdf.tecnico" >RESP. VISITA TÉCNICA: <b>{{dataDetailsPdf.tecnico.nome}}</b></td>
                        <td class="table-pdf-td">
                            <div class="dataandhour">
                               <div>
                                 DATA:
                                 <b>
                                    {{dataDetailsPdf.dataString}}
                                </b>
                               </div>
                               <div>
                                HORA:
                                <b>
                                    {{dataDetailsPdf.horario == null ? "HORÁRIO NÃO CADASTRADO" : formatHours(dataDetailsPdf.horario)}}
                                </b>
                               </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="sub-title">2 - DESCRIÇÃO DA SOLICITAÇÃO</div>
            <table class="table-pdf">
                <thead></thead>
                <tbody>
                    <tr>
                         <td class="td-tratamento">{{dataDetailsPdf.descricao}}</td>
                    </tr>
                    <tr>
                        <td class="td-tratamento"></td>
                    </tr>
                    <tr>
                        <td class="td-tratamento"></td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex sub-title">3 - PARECER DA VISITA TÉCNICA GARANTIA <input type="checkbox"  id="check-garantia-true" class=" ml-3 mr-1"/>SIM <input type="checkbox" id="check-garantia-false" class="ml-3 mr-1"/>NÃO</div>
            <table class="table-pdf">
                <thead></thead>
                <tbody>
                    <tr>
                        <td class="td-tratamento"></td>
                    </tr>
                    <tr>
                        <td class="td-tratamento"></td>
                    </tr>
                    <tr>
                        <td class="td-tratamento"></td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex sub-title">3.1 - TIPOS DE PATOLOGIAS <input type="checkbox"   class=" ml-3 mr-1" />Manutenção Completa <input type="checkbox"  class="ml-3 mr-1" />Manutenção Incompleta </div>

            <table class="w-100">
                <thead></thead>
                <tbody>
                    <tr>
                        <td class="check-patologia-td">
                            <div class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-2"  class="mr-2"/>
                                <div>Pisos e Revestimento</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                            <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-1"  class="mr-2"/>
                                <div>Elétrica</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                            <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-4"  class="mr-2"/>
                                <div>Vedação Interna e Externas</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                             <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-5"  class="mr-2"/>
                                <div>Pintura</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                            <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-6"  class="mr-2"/>
                                <div>Louças e Metais</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="check-patologia-td">
                            <div class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-7" class="mr-2"/>
                                <div>Hidráulica</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                            <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-0"  class="mr-2"/>
                                <div>Infiltração</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                            <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-3"  class="mr-2"/>
                                <div>Esquadrias, janelas e portas</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                             <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-8"  class="mr-2"/>
                                <div>Tubulações</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                            <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-9"  class="mr-2"/>
                                <div>Estrutura</div>
                            </div>
                        </td>
                    </tr>
                     <tr>
                        <td class="check-patologia-td">
                            <div class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-10"  class="mr-2"/>
                                <div>Impermeabilização</div>
                            </div>
                        </td>
                        <td class="check-patologia-td">
                            <div  class="d-flex check-table">
                                <input type="checkbox" id="check-patologia-11"  class="mr-2"/>
                                <div>Outros</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
                <div class="d-flex justify-content-between">
                </div>
            <div class="d-flex sub-title"> 4 - AÇÕES PARA TRATAMENTO/MOTIVO DE IMPROCEDÊNCIA<input type="checkbox" class=" ml-3 mr-1 testechek" />Tratamento Procedente<input type="checkbox" class="ml-3 mr-1" />Tratamento Improcedente </div>
            <table class="w-100">
                <thead></thead>
                <tbody>
                    <tr>
                        <td colspan="2" class="td-tratamento"><b>Descrição</b></td>
                    </tr>
                    <tr>
                        <td  colspan="2" class="td-tratamento"></td>
                    </tr>
                    <tr>
                        <td class="td-tratamento w-50"></td>
                        <td class="td-tratamento w-50"><b>Custo Estimado</b></td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex sub-title">5 - AVALIAÇÃO DO CLIENTE</div>
            <table class="w-100">
                <thead>
                    <tr>
                        <th class="td-avaliacao-cl">Descrição</th>
                        <th class="text-center td-availiacao-check">Ótimo</th>
                        <th class="text-center td-availiacao-check">Bom</th>
                        <th class="text-center td-availiacao-check">Regular</th>
                        <th class="text-center td-availiacao-check">Ruim</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="td-avaliacao-cl">Qualidade dos serviços prestados</td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                    </tr>
                    <tr>
                         <td class="td-avaliacao-cl">Tempo de resposta para atendimento</td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                    </tr>
                    <tr>
                        <td class="td-avaliacao-cl">Comportamento e cordialidade</td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                    </tr>
                    <tr>
                        <td class="td-avaliacao-cl">Organização e Limpeza</td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                        <td class="td-availiacao-check"></td>
                    </tr>
                </tbody>
            </table>

            <div class="d-flex sub-title">6 - TERMO DE ACEITAÇÃO FINAL</div>
            <!-- <p><b>Eu,</b> {{ dataDetailsPdf.nomeCliente}} acima citado, declaro que os serviços/esckarecunebtis correspondem á solicitação apontadas neste relatório, foram realizadas/ prestadas a contento de forma clara e objetiva, Por tanto, estando ciente e
            não tendo mais nada a reclamar, <b>aceito</b></p> -->

            <div class="d-flex w-100 justify-content-between assinatura-body">
                <div class=" w-25">
                    <div class="assinatura-row"></div>
                    <div class="text-center mt-3"><b>Visto Repres. da Empresa</b></div>
                </div>
                <div class=" w-25">
                    <div class="assinatura-row"></div>
                    <div class="text-center mt-3"><b>Nome e Assinat. Cliente</b></div>
                </div>
                <div class=" w-25">
                    <div class="assinatura-row"></div>
                    <div class="text-center mt-3"><b>Eng. Coord. QMA</b></div>
                </div>
            </div>

       </div>
      </section>
    </vue-html2pdf>
    <div>
    </div>
  </div>
</template>

<script>
import DetailsOcurrence from '@/views/private/realestate/ocurrence/components/ocurrenceDetails/detailsOcurrence.js'
export default DetailsOcurrence
</script>

<style scoped>
.check-patologia-td{
    height: 25px;
    min-height: 25px;
    max-height: 25px;
}
.main-container{
    position: relative;
}
.painel-detalhes-main{
    height: 73vh;
    overflow: auto;
    font-family: 'Segoe UI';
}

.painel-detalhes-main::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 15px;
}
.painel-detalhes-main::-webkit-scrollbar {
    width: 10px;
    height: 10px;
     border-radius: 9px;
    background: #F4F4F4;
}
.painel-detalhes-main::-webkit-scrollbar-thumb {
    background: rgb(192, 193, 192);
    border-radius: 9px;
}

/* PDF */
.container-pdf{
    padding: 3px 20px 5px 20px;
}
.table-pdf{
    border: 1px solid black;
    width: 100%;
}
.assinatura-body{
    margin-top: 60px;
}
.testechek{
 accent-color: green;
}
.pdf-header{
    height: 7vh;
    display: flex;
    align-items: center;
    padding-left: 25px;
    background: #e4e5e6;
}

.codigoposition{
    padding-left: 685px;
    /* display: flex;
    height: 100%;
    width: 100%;
    justify-content: end;
    align-items: center; */
}

.sub-title{
    font-weight: bold;
    margin-bottom: 5px;
    margin-top: 25px;
}
.td-tratamento{
    min-height: 25px;
    max-height: 25px;
    height: 25px;
    padding-left: 15px;
    border: 1px solid gray;
    width: 100%;
}
.assinatura-row{
    width: 100%;
    height: 2px;
    background: gray;
}
.table-pdf-td{
    border: 1px solid gray;
    width: 50%;
    padding-left: 10px;
    min-height: 25px;
    height: 25px;
    max-height: 25px;
}
.td-avaliacao-cl{
    width: 60%;
    min-height: 25px;
     height: 25px;
    max-height: 25px;
    padding-left: 10px;
    border: 1px solid gray;
}
.size-logo-inco-pdf{
    height: 50px;
    width: 250px;
}
.td-availiacao-check{
    width: 10%;
    height: 25px;
    min-height: 25px;
    max-height: 25px;
    padding-left: 10px;
    border: 1px solid gray;
}
.check-table
{
    height: 15px;
    display: flex;
    align-items: center;
}
.heigth-empty-col
{
    height: 25px;
    min-height: 25px;
    max-height: 25px;

}
.dataandhour{
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-right: 25px;
}

@media  (max-width: 1280px) {
.painel-detalhes-main{
    height: 88vh;
    overflow: auto;
    font-family: 'Segoe UI';
}
.painel-detalhes-main::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 15px;
}
.painel-detalhes-main::-webkit-scrollbar {
    width: 10px;
    height: 10px;
     border-radius: 9px;
    background: #F4F4F4;
}
.painel-detalhes-main::-webkit-scrollbar-thumb {
    background: rgb(192, 193, 192);
    border-radius: 9px;
}

}
@media (min-width: 1281px ) and (max-width: 1400px) {
    .painel-detalhes-main{
        height: 70vh;
        overflow: auto;
        font-family: 'Segoe UI';
    }
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/ocurrenceDetails/detailsOcurrence.vue